/* Self-contained toy. No Shopify, cart, network, storage or customer data access. */
(() => {
  if (customElements.get('fs-tee-catch')) return;
  const levels = {
    easy: { speed: 100, interval: .85, width: 96, label: 'EASY' },
    normal: { speed: 145, interval: .65, width: 80, label: 'NORMAL' },
    hard: { speed: 195, interval: .48, width: 66, label: 'HARD' },
  };
  class TeeCatch extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.field = this.querySelector('.fs-play__field');
      this.startButton = this.querySelector('[data-start]');
      this.stopButton = this.querySelector('[data-stop]');
      this.position = this.querySelector('[data-position]');
      this.status = this.querySelector('[data-status]');
      this.levelInputs = [...this.querySelectorAll('.fs-play__difficulty input')];
      this.basket = this.querySelector('[data-basket]');
      this.mode = levels.easy;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.items = [];
      this.startButton.addEventListener('click', () => this.start(), options);
      this.stopButton.addEventListener('click', () => this.finish('終了しました。'), options);
      this.position.addEventListener('input', () => this.move(), options);
      this.levelInputs.forEach(input => input.addEventListener('change', () => {
        if (this.running) return;
        this.mode = levels[input.value] || levels.easy;
        this.move();
        this.status.textContent = `${this.mode.label}：難易度を選んだらスタート。`;
      }, options));
      const pointerMove = event => {
        if (!this.running || this.dragging !== event.pointerId) return;
        const rect = this.field.getBoundingClientRect();
        const travel = Math.max(1, rect.width - this.mode.width);
        this.position.value = String(Math.max(0, Math.min(100, (event.clientX - rect.left - this.mode.width / 2) / travel * 100)));
        this.move();
      };
      this.field.addEventListener('pointerdown', event => {
        if (!this.running) return;
        this.dragging = event.pointerId;
        this.field.setPointerCapture(event.pointerId);
        pointerMove(event);
      }, options);
      this.field.addEventListener('pointermove', pointerMove, options);
      for (const event of ['pointerup', 'pointercancel']) this.field.addEventListener(event, () => { this.dragging = null; }, options);
      this.resizeObserver = new ResizeObserver(() => this.move());
      this.resizeObserver.observe(this.field);
      document.addEventListener('visibilitychange', () => { if (document.hidden && this.running) this.finish('画面を離れたため終了しました。'); }, options);
      this.motion.addEventListener('change', () => { this.finish(''); this.availability(); }, options);
      this.observer = new IntersectionObserver(entries => { if (!entries[0].isIntersecting && this.running) this.finish('ゲームの外へ移動したため終了しました。'); });
      this.observer.observe(this);
      this.availability();
    }
    availability() {
      this.startButton.disabled = this.motion.matches;
      this.status.textContent = this.motion.matches ? '「動きを減らす」設定のため、落下ゲームは停止しています。' : 'スタートを押すとTシャツが降ってきます。';
    }
    move() {
      this.basketX = Math.max(0, this.field.clientWidth - this.mode.width) * Number(this.position.value) / 100;
      this.basket.style.width = `${this.mode.width}px`;
      this.basket.style.left = `${this.basketX}px`;
    }
    start() {
      if (this.motion.matches || this.running) return;
      this.clear();
      this.score = 0; this.elapsed = 0; this.spawnTime = 0; this.previous = 0;
      this.querySelector('[data-score]').textContent = '0';
      this.querySelector('[data-time]').textContent = '15';
      this.running = true;
      this.mode = levels[this.levelInputs.find(input => input.checked)?.value] || levels.easy;
      this.classList.add('is-playing');
      this.levelInputs.forEach(input => { input.disabled = true; });
      this.startButton.disabled = true; this.stopButton.disabled = false; this.position.disabled = false;
      this.position.value = '50'; this.move();
      this.status.textContent = `${this.mode.label} スタート！カゴを動かしてキャッチ。`;
      this.position.focus({ preventScroll: true });
      this.frame = requestAnimationFrame(t => this.tick(t));
    }
    spawn() {
      const el = this.querySelector('[data-tee]').content.firstElementChild.cloneNode(true);
      const colors = ['#7cbdf2', '#f7db65', '#fafbfc', '#72bbaa'];
      el.style.color = colors[Math.floor(Math.random() * colors.length)];
      const x = Math.random() * Math.max(0, this.field.clientWidth - 48);
      this.items.push({ el, x, y: -48, tilt: Math.random() * 16 - 8 }); this.field.append(el);
    }
    tick(time) {
      if (!this.running) return;
      if (!this.isConnected) { this.finish(''); return; }
      const dt = this.previous ? Math.min((time - this.previous) / 1000, .1) : 0;
      this.previous = time; this.elapsed += dt; this.spawnTime -= dt;
      const remaining = Math.max(0, 15 - this.elapsed);
      this.querySelector('[data-time]').textContent = String(Math.ceil(remaining));
      if (!remaining) { this.finish('タイムアップ！'); return; }
      if (this.spawnTime <= 0) { this.spawn(); this.spawnTime = this.mode.interval; }
      const catchY = this.field.clientHeight - 60;
      for (const item of [...this.items]) {
        const previousBottom = item.y + 46;
        item.y += dt * this.mode.speed;
        item.x = Math.min(item.x, Math.max(0, this.field.clientWidth - 48));
        const center = item.x + 24;
        const caught = previousBottom <= catchY && item.y + 46 >= catchY && center >= this.basketX && center <= this.basketX + this.mode.width;
        if (caught || item.y > this.field.clientHeight) {
          if (caught) { this.score++; this.querySelector('[data-score]').textContent = String(this.score); this.basket.animate?.([{transform:'translateY(0)'},{transform:'translateY(3px)'},{transform:'translateY(0)'}],{duration:160}); }
          item.el.remove(); this.items.splice(this.items.indexOf(item), 1);
        } else item.el.style.transform = `translate(${item.x}px, ${item.y}px) rotate(${item.tilt + Math.sin(item.y / 35) * 3}deg)`;
      }
      this.frame = requestAnimationFrame(t => this.tick(t));
    }
    clear() { cancelAnimationFrame(this.frame); this.items?.forEach(i => i.el.remove()); this.items = []; }
    finish(message) {
      const wasRunning = this.running;
      this.running = false; this.clear();
      this.classList.remove('is-playing'); this.dragging = null;
      this.levelInputs.forEach(input => { input.disabled = false; });
      this.startButton.disabled = this.motion.matches;
      this.stopButton.disabled = true; this.position.disabled = true;
      if (wasRunning) { this.status.textContent = `${message} ${this.mode.label}で${this.score}枚キャッチ。また遊べます。`; this.startButton.textContent = 'もう一度あそぶ'; }
    }
    disconnectedCallback() {
      this.running = false; this.clear(); this.observer?.disconnect(); this.resizeObserver?.disconnect(); this.abort?.abort(); this.abort = null;
    }
  }
  customElements.define('fs-tee-catch', TeeCatch);
})();
